import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

// Attach token from localStorage if available
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const formatApiError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};

// Auth
export const apiLogin = (email, password) =>
  api.post('/auth/login', { email, password });

export const apiLogout = () => api.post('/auth/logout');

export const apiGetMe = () => api.get('/auth/me');

// Public
export const apiGetCreators = () => api.get('/creators');
export const apiGetBrands = () => api.get('/brands');
export const apiGetSettings = () => api.get('/settings');
export const apiSubmitContact = (data) => api.post('/contact', data);

// Resolves an image URL — if it's a relative API path, prepend backend URL
export const resolveImageUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  if (url.startsWith('/api/')) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
};

// Admin: Uploads
export const apiUploadImage = (file) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/admin/uploads', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

// Admin: Creators
export const apiCreateCreator = (data) => api.post('/admin/creators', data);
export const apiUpdateCreator = (id, data) => api.put(`/admin/creators/${id}`, data);
export const apiDeleteCreator = (id) => api.delete(`/admin/creators/${id}`);

// Admin: Brands
export const apiCreateBrand = (data) => api.post('/admin/brands', data);
export const apiUpdateBrand = (id, data) => api.put(`/admin/brands/${id}`, data);
export const apiDeleteBrand = (id) => api.delete(`/admin/brands/${id}`);

// Admin: Submissions
export const apiGetSubmissions = () => api.get('/admin/submissions');
export const apiMarkSubmissionRead = (id) => api.put(`/admin/submissions/${id}/read`);
export const apiDeleteSubmission = (id) => api.delete(`/admin/submissions/${id}`);

// Admin: Settings
export const apiUpdateSettings = (data) => api.put('/admin/settings', data);

export default api;
